import { render } from "./BottomUpModal.vue?vue&type=template&id=577aa530"
import script from "./BottomUpModal.vue?vue&type=script&lang=js"
export * from "./BottomUpModal.vue?vue&type=script&lang=js"

import "./BottomUpModal.vue?vue&type=style&index=0&id=577aa530&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__